import React from 'react';
import bem from 'utils/bem.js';
import Text from 'components/Text/index.js';
import Icon from 'components/Icon';
import './index.sass';

const { block, el } = bem('no-user-placeholder')
export const NoUserPlaceholder = () => {
    return (
        <div className={block()}>
            <Icon name={'bird'} />
            <Text serif className={el('title')}>Ожидание собеседника</Text>
        </div>
    )
}
